/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { nativeFbConditions } from "@almamedia/amr-adtech-stack/lib/services/native/templates/native-fb-ad";
import { IPlacementsConfiguration } from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { dispatchAdRequestFinished } from "../custom-needs/custom-needs";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";

const placements: IPlacementsConfiguration<
  ICustomVariables,
  SiteNativeTemplate
> = {
  searchpage_mobile: [],
  searchpage_tablet: [],
  searchpage_desktop: [
    {
      divId: "almad-skyscraper-1",
      placementId: 13928996,
      sizes: [[160, 600], [200, 600], [250, 600]],
      friendlyName: "Valtti_hakusivu_160x600_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_skyscraper_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 14791449,
      sizes: [[980, 120]],
      friendlyName: "Valtti_hakusivu_980x400_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  "searchpage_desktop-wide": [
    {
      divId: "almad-skyscraper-1",
      placementId: 13928996,
      sizes: [[160, 600], [200, 600], [250, 600]],
      friendlyName: "Valtti_hakusivu_160x600_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_skyscraper_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 14791449,
      sizes: [[980, 120]],
      friendlyName: "Valtti_hakusivu_980x400_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "searchpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  searchresultpage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 12564622,
      sizes: [
        [320, 320],
        [320, 300],
        [300, 300],
        [300, 150],
        [300, 250],
        [1, 1],
      ],
      friendlyName: "Etuovi.com_hakutulossivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-parade-2",
      placementId: 12564625,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 150],
        [300, 431],
        [300, 250],
        [300, 600],
      ],
      friendlyName: "Etuovi.com_hakutulossivu_300x300_ala_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_2",
      },
    },
    {
      divId: "almad-list-1",
      placementId: 12773771,
      sizes: [
        [300, 300],
        [300, 250],
        [300, 431],
        [320, 320],
        [320, 300],
        [300, 150],
        [300, 600],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName:
        "Etuovi.com_hakutulossivu_300x300_välimainos_1_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      native: {
        templateSelector: (context, adObject) => {
          if (nativeFbConditions(adObject)) {
            return "native_fb_ad";
          }
          return "native_square_blue";
        },
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_list_1",
      },
    },
    {
      divId: "almad-list-2",
      placementId: 13502232,
      sizes: [[300, 300], [300, 250], [320, 320], [320, 300]],
      friendlyName:
        "Etuovi.com_hakutulossivu_300x300_välimainos_2_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_list_2",
      },
    },
    {
      divId: "almad-list-3",
      placementId: 13502241,
      sizes: [[300, 300], [300, 250], [320, 320], [320, 300]],
      friendlyName:
        "Etuovi.com_hakutulossivu_300x300_välimainos_3_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_list_3",
      },
    },
    // waiting correct placementId: { divId: "almad-list-4", placementId: 13502241, sizes: [[300, 300]], "friendlyName": "Etuovi.com_hakutulossivu_300x300_välimainos_4_mobile (Valtti)" },
    // waiting correct placementId: { divId: "almad-list-5", placementId: 13502241, sizes: [[300, 300]], "friendlyName": "Etuovi.com_hakutulossivu_300x300_välimainos_5_mobile (Valtti)" }
  ],
  searchresultpage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 12564622,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 150],
        [300, 250],
        [1, 1],
      ],
      friendlyName: "Etuovi.com_hakutulossivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-parade-2",
      placementId: 12564625,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 150],
        [300, 431],
        [300, 250],
        [300, 600],
      ],
      friendlyName: "Etuovi.com_hakutulossivu_300x300_ala_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_2",
      },
    },
    {
      divId: "almad-list-1",
      placementId: 12773771,
      sizes: [
        [300, 300],
        [300, 250],
        [320, 320],
        [320, 300],
        [300, 431],
        [300, 600],
        [1, 1],
      ],
      adType: ["banner", "native"],
      friendlyName:
        "Etuovi.com_hakutulossivu_300x300_välimainos_1_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      native: {
        templateSelector: (context, adObject) => {
          if (nativeFbConditions(adObject)) {
            return "native_fb_ad";
          }
          return "native_square_blue";
        },
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_list_1",
      },
    },
    {
      divId: "almad-list-2",
      placementId: 13502232,
      sizes: [[300, 300], [300, 250], [320, 320], [320, 300]],
      friendlyName:
        "Etuovi.com_hakutulossivu_300x300_välimainos_2_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_list_2",
      },
    },
    {
      divId: "almad-list-3",
      placementId: 13502241,
      sizes: [[300, 300], [300, 250], [320, 320], [320, 300]],
      friendlyName:
        "Etuovi.com_hakutulossivu_300x300_välimainos_3_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_list_3",
      },
    },
    // waiting correct placementId: { divId: "almad-list-4", placementId: 13502241, sizes: [[300, 300]], "friendlyName": "Etuovi.com_hakutulossivu_300x300_välimainos_4_mobile (Valtti)" },
    // waiting correct placementId: { divId: "almad-list-5", placementId: 13502241, sizes: [[300, 300]], "friendlyName": "Etuovi.com_hakutulossivu_300x300_välimainos_5_mobile (Valtti)" }
  ],
  searchresultpage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 13520781,
      sizes: [[980, 400], [980, 120], [1, 1]],
      friendlyName: "Etuovi.com_hakutulossivu_980x400_ylä_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-parade-2",
      placementId: 13520783,
      sizes: [
        [980, 400],
        [980, 120],
        [300, 431],
        [300, 250],
        [600, 250],
        [468, 400],
        [300, 300],
      ],
      friendlyName: "Etuovi.com_hakutulossivu_980x400_ala_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_2",
      },
    },
    {
      divId: "almad-list-1",
      placementId: 13502302,
      sizes: [[980, 120], [324, 640], [1, 1]],
      adType: ["banner", "native"],
      friendlyName:
        "Etuovi.com_hakutulossivu_980x120_välimainos_1_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      native: {
        template: "native_rectangle_black_wide",
      },
      prebid: {
        active: !0,
        source: "ros_almad_list_1",
      },
    },
    {
      divId: "almad-list-2",
      placementId: 13502303,
      sizes: [[980, 120]],
      friendlyName:
        "Etuovi.com_hakutulossivu_980x120_välimainos_2_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_list_2",
      },
    },
    {
      divId: "almad-list-3",
      placementId: 13502304,
      sizes: [[980, 120]],
      friendlyName:
        "Etuovi.com_hakutulossivu_980x120_välimainos_3_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_list_3",
      },
    },
    // waiting correct placementId: { divId: "almad-list-4", placementId: 13502304, sizes: [[980, 120]], "friendlyName": "Etuovi.com_hakutulossivu_980x120_välimainos_4_desktop (Valtti)" },
    // waiting correct placementId: { divId: "almad-list-5", placementId: 13502304, sizes: [[980, 120]], "friendlyName": "Etuovi.com_hakutulossivu_980x120_välimainos_5_desktop (Valtti)" }
  ],
  "searchresultpage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 13520781,
      sizes: [[980, 400], [980, 120], [1, 1]],
      friendlyName: "Etuovi.com_hakutulossivu_980x400_ylä_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-parade-2",
      placementId: 13520783,
      sizes: [
        [980, 400],
        [980, 120],
        [300, 250],
        [600, 250],
        [468, 400],
        [300, 431],
        [300, 300],
      ],
      friendlyName: "Etuovi.com_hakutulossivu_980x400_ala_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_2",
      },
    },
    {
      divId: "almad-list-1",
      placementId: 13502302,
      sizes: [[980, 120], [324, 640], [980, 401], [1, 1]],
      adType: ["banner", "native"],
      friendlyName:
        "Etuovi.com_hakutulossivu_980x120_välimainos_1_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),

        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      native: {
        template: "native_rectangle_black_wide",
      },
      prebid: {
        active: !0,
        source: "ros_almad_list_1",
      },
    },
    {
      divId: "almad-list-2",
      placementId: 13502303,
      sizes: [[980, 120]],
      friendlyName:
        "Etuovi.com_hakutulossivu_980x120_välimainos_2_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_list_2",
      },
    },
    {
      divId: "almad-list-3",
      placementId: 13502304,
      sizes: [[980, 120]],
      friendlyName:
        "Etuovi.com_hakutulossivu_980x120_välimainos_3_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_list_3",
      },
    },
    // waiting correct placementId: { divId: "almad-list-4", placementId: 13502304, sizes: [[980, 120]], "friendlyName": "Etuovi.com_hakutulossivu_980x120_välimainos_4_desktop (Valtti)" },
    // waiting correct placementId: { divId: "almad-list-5", placementId: 13502304, sizes: [[980, 120]], "friendlyName": "Etuovi.com_hakutulossivu_980x120_välimainos_5_desktop (Valtti)" }
    {
      divId: "almad-wallpaper-1",
      placementId: 14006206,
      sizes: [[1600, 1200], [1920, 1200]],
      friendlyName: "Etuovi.com_hakutulossivu_1600x1200_tapetti (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
            dispatchAdRequestFinished(adObject.targetId, "searchresultpage", false),
        adAvailable: (context, adObject) => {
            window.document.body.id = "wallpaper-active";
            dispatchAdRequestFinished(adObject.targetId, "searchresultpage", true);
        },
      },
    },
  ],
  mapsearchresultpage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 12564622,
      sizes: [[320, 320], [320, 300], [300, 300], [300, 150], [300, 250]],
      friendlyName: "Etuovi.com_hakutulossivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  mapsearchresultpage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 12564622,
      sizes: [[300, 300], [320, 320], [320, 300], [300, 150], [300, 250]],
      friendlyName: "Etuovi.com_hakutulossivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  mapsearchresultpage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 13520781,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_hakutulossivu_980x400_ylä_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  "mapsearchresultpage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 13520781,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_hakutulossivu_980x400_ylä_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "searchresultpage",
            true
          ),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  frontpage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 12564618,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300], [300, 250]],
      friendlyName: "Etuovi.com_etusivu_300x300_mobile (Valtti)",
      lazyload: {
        disable: false,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  frontpage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 12564618,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300], [300, 250]],
      friendlyName: "Etuovi.com_etusivu_300x300_mobile (Valtti)",
      lazyload: {
        disable: false,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  frontpage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 13520779,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_etusivu_980x400_ylä_desktop (Valtti)",
      lazyload: {
        disable: false,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    // not implemented yet: { divId: "almad-parade-2", placementId: 13520780, sizes: [[980, 400], [980, 120]], "friendlyName": "Etuovi.com_etusivu_980x400_ala_desktop (Valtti)" }
    // not implemented yet: { divId: "almad-wallpaper-1", placementId: 14006205, sizes: [[1600, 1200]], "friendlyName": "Etuovi.com_etusivu_1600x1200_tapetti (Valtti)" }
  ],
  "frontpage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 13520779,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_etusivu_980x400_ylä_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    // not implemented yet: { divId: "almad-parade-2", placementId: 13520780, sizes: [[980, 400], [980, 120]], "friendlyName": "Etuovi.com_etusivu_980x400_ala_desktop (Valtti)" }
    // not implemented yet: { divId: "almad-wallpaper-1", placementId: 14006205, sizes: [[1600, 1200]], "friendlyName": "Etuovi.com_etusivu_1600x1200_tapetti (Valtti)" }
    {
      divId: "almad-wallpaper-1",
      placementId: 14006205,
      sizes: [[1600, 1200], [1920, 1200]],
      friendlyName: "Etuovi.com_hakutulossivu_1600x1200_tapetti (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) => {
          window.document.body.id = "wallpaper-active";
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true);
        },
      },
    },
  ],
  itempage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 12722869,
      sizes: [[300, 300], [320, 320], [320, 300], [300, 150]],
      friendlyName: "Etuovi.com_kohdesivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 12722869,
      sizes: [[300, 300], [320, 320], [320, 300], [300, 150]],
      friendlyName: "Etuovi.com_kohdesivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 13520784,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_kohdesivu_980x400_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  "itempage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 13520784,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_kohdesivu_980x400_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  loanpage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 20586752,
      sizes: [[300, 300]],
      friendlyName: "Valtti_lainalaskuri_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  loanpage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 20586752,
      sizes: [[300, 300]],
      friendlyName: "Valtti_lainalaskuri_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  loanpage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 20586750,
      sizes: [[980, 120]],
      friendlyName: "Valtti_lainalaskuri_980x120_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  "loanpage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 20586750,
      sizes: [[980, 120]],
      friendlyName: "Valtti_lainalaskuri_980x120_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "loanpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  myannouncementlandingpage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 15200761,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300]],
      friendlyName: "Valtti_myy_itse_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            true
          ),
      },
    },
  ],
  myannouncementlandingpage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 15200761,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300]],
      friendlyName: "Valtti_myy_itse_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            true
          ),
      },
    },
  ],
  myannouncementlandingpage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 15200805,
      sizes: [[980, 120], [980, 400]],
      friendlyName: "Valtti_myy_itse_980x400_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            true
          ),
      },
    },
  ],
  "myannouncementlandingpage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 15200805,
      sizes: [[980, 120], [980, 400]],
      friendlyName: "Valtti_myy_itse_980x400_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementlandingpage",
            true
          ),
      },
    },
  ],
  areapage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 13929014,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300]],
      friendlyName: "Valtti_aluesivu_300x300_ylä_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13929019,
      sizes: [[300, 250]],
      friendlyName: "Valtti_aluesivu_300x250_boksi_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_2",
      },
    },
  ],
  areapage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 13929014,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300]],
      friendlyName: "Valtti_aluesivu_300x300_ylä_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13929019,
      sizes: [[300, 250]],
      friendlyName: "Valtti_aluesivu_300x250_boksi_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_2",
      },
    },
  ],
  areapage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 13929007,
      sizes: [[980, 120], [980, 400]],
      friendlyName: "Valtti_aluesivu_980x400_ylä_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13929016,
      sizes: [[300, 250]],
      friendlyName: "Valtti_aluesivu_300x250_boksi_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_rectangle_1",
      },
    },
  ],
  "areapage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 13929007,
      sizes: [[980, 120], [980, 400]],
      friendlyName: "Valtti_aluesivu_980x400_ylä_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-rectangle-1",
      placementId: 13929016,
      sizes: [[300, 250]],
      friendlyName: "Valtti_aluesivu_300x250_boksi_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "areapage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_rectangle_1",
      },
    },
  ],
  frontpage_mobile_interstitial: [
    {
      divId: "almad-interstitial-1",
      placementId: 13942014,
      sizes: [[7, 1]],
      friendlyName: "Valtti_etusivu_digietusivu_mobile",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 12564618,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300], [300, 250]],
      friendlyName: "Etuovi.com_etusivu_300x300_mobile (Valtti)",
      lazyload: {
        disable: false,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  frontpage_tablet_interstitial: [
    {
      divId: "almad-interstitial-1",
      placementId: 13942014,
      sizes: [[7, 1]],
      friendlyName: "Valtti_etusivu_digietusivu_mobile",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 12564618,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300], [300, 250]],
      friendlyName: "Etuovi.com_etusivu_300x300_mobile (Valtti)",
      lazyload: {
        disable: false,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_mobile_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
  ],
  frontpage_desktop_interstitial: [
    {
      divId: "almad-interstitial-1",
      placementId: 13949008,
      sizes: [[7, 1]],
      friendlyName: "Valtti_etusivu_digietusivu_dektop",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 13520779,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_etusivu_980x400_ylä_desktop (Valtti)",
      lazyload: {
        disable: false,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    // not implemented yet: { divId: "almad-parade-2", placementId: 13520780, sizes: [[980, 400], [980, 120]], "friendlyName": "Etuovi.com_etusivu_980x400_ala_desktop (Valtti)" }
  ],
  "frontpage_desktop-wide_interstitial": [
    {
      divId: "almad-interstitial-1",
      placementId: 13949008,
      sizes: [[7, 1]],
      friendlyName: "Valtti_etusivu_digietusivu_dektop",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 13520779,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_etusivu_980x400_ylä_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true),
      },
      prebid: {
        active: !0,
        source: "ros_almad_parade_1",
        rubicon: {
          params: {
            position: "atf",
          },
        },
      },
    },
    {
      divId: "almad-wallpaper-1",
      placementId: 14006205,
      sizes: [[1600, 1200], [1920, 1200]],
      friendlyName: "Etuovi.com_etusivu_1600x1200_tapetti (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "frontpage", false),
        adAvailable: (context, adObject) => {
          window.document.body.id = "wallpaper-active";
          dispatchAdRequestFinished(adObject.targetId, "frontpage", true);
        },
      },
    },
    // not implemented yet: { divId: "almad-parade-2", placementId: 13520780, sizes: [[980, 400], [980, 120]], "friendlyName": "Etuovi.com_etusivu_980x400_ala_desktop (Valtti)" }
  ],
  itempage_mobile_interstitial: [
    {
      divId: "almad-interstitial-1",
      placementId: 13948995,
      sizes: [[7, 1]],
      friendlyName: "Valtti_kohdesivu_digietusivu_mobile",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 12722869,
      sizes: [[300, 300], [320, 320], [320, 300], [300, 150]],
      friendlyName: "Etuovi.com_kohdesivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_tablet_interstitial: [
    {
      divId: "almad-interstitial-1",
      placementId: 13948995,
      sizes: [[7, 1]],
      friendlyName: "Valtti_kohdesivu_digietusivu_mobile",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 12722869,
      sizes: [[300, 300], [300, 150], [320, 320], [320, 300]],
      friendlyName: "Etuovi.com_kohdesivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_desktop_interstitial: [
    {
      divId: "almad-interstitial-1",
      placementId: 13949010,
      sizes: [[7, 1]],
      friendlyName: "Valtti_kohdesivu_digietusivu_desktop",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 13520784,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_kohdesivu_980x400_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  "itempage_desktop-wide_interstitial": [
    {
      divId: "almad-interstitial-1",
      placementId: 13949010,
      sizes: [[7, 1]],
      friendlyName: "Valtti_kohdesivu_digietusivu_desktop",
      lazyload: {
        disable: true,
      },
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 13520784,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_kohdesivu_980x400_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_mobile_marketplace: [
    {
      divId: "almad-marketplace-1",
      placementId: 14435101,
      sizes: [[300, 300]],
      friendlyName:
        "Etuovi.com_kohdesivu_300x300_adAlternative_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 12722869,
      sizes: [[300, 300], [320, 320], [320, 300], [300, 150]],
      friendlyName: "Etuovi.com_kohdesivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_tablet_marketplace: [
    {
      divId: "almad-marketplace-1",
      placementId: 14435101,
      sizes: [[300, 300]],
      friendlyName:
        "Etuovi.com_kohdesivu_300x300_adAlternative_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 12722869,
      sizes: [[300, 300], [320, 320], [320, 300], [300, 150]],
      friendlyName: "Etuovi.com_kohdesivu_300x300_ylä_mobile (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  itempage_desktop_marketplace: [
    {
      divId: "almad-marketplace-1",
      placementId: 14435097,
      sizes: [[980, 120], [980, 400]],
      friendlyName:
        "Etuovi.com_kohdesivu_980x120_adAlternative_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 13520784,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_kohdesivu_980x400_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  "itempage_desktop-wide_marketplace": [
    {
      divId: "almad-marketplace-1",
      placementId: 14435097,
      sizes: [[980, 120], [980, 400]],
      friendlyName:
        "Etuovi.com_kohdesivu_980x120_adAlternative_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
    {
      divId: "almad-parade-1",
      placementId: 13520784,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Etuovi.com_kohdesivu_980x400_desktop (Valtti)",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", false),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(adObject.targetId, "itempage", true),
      },
    },
  ],
  // MALTTI
  myannouncementpage_mobile: [
    {
      divId: "almad-parade-1",
      placementId: 14010906,
      sizes: [
        [300, 300],
        [320, 320],
        [320, 300],
        [300, 150],
        [300, 431],
        [300, 600],
      ],
      friendlyName: "Valtti_myynti-ilmoitus_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            true
          ),
      },
    },
  ],
  myannouncementpage_tablet: [
    {
      divId: "almad-parade-1",
      placementId: 14010906,
      sizes: [[300, 300], [320, 300], [300, 150], [300, 431], [300, 600]],
      friendlyName: "Valtti_myynti-ilmoitus_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            true
          ),
      },
    },
  ],
  myannouncementpage_desktop: [
    {
      divId: "almad-parade-1",
      placementId: 14010912,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Valtti_myynti-ilmoitus_980x120_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            true
          ),
      },
    },
  ],
  "myannouncementpage_desktop-wide": [
    {
      divId: "almad-parade-1",
      placementId: 14010912,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Valtti_myynti-ilmoitus_980x120_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "myannouncementpage",
            true
          ),
      },
    },
  ],
  pricingresultpage_mobile: [
    {
      divId: "almad-parade-2",
      placementId: 14010915,
      sizes: [[300, 300], [300, 150], [300, 431], [300, 600]],
      friendlyName: "Valtti_hintalaskuri_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            true
          ),
      },
    },
  ],
  pricingresultpage_tablet: [
    {
      divId: "almad-parade-2",
      placementId: 14010915,
      sizes: [[300, 300], [300, 150], [300, 431], [300, 600]],
      friendlyName: "Valtti_hintalaskuri_300x300_mobile",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            true
          ),
      },
    },
  ],
  pricingresultpage_desktop: [
    {
      divId: "almad-parade-2",
      placementId: 14010920,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Valtti_hintalaskuri_980x120_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            true
          ),
      },
    },
  ],
  "pricingresultpage_desktop-wide": [
    {
      divId: "almad-parade-2",
      placementId: 14010920,
      sizes: [[980, 400], [980, 120]],
      friendlyName: "Valtti_hintalaskuri_980x120_desktop",
      customNeeds: {
        adNoBid: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            false
          ),
        adAvailable: (context, adObject) =>
          dispatchAdRequestFinished(
            adObject.targetId,
            "pricingresultpage",
            true
          ),
      },
    },
  ],
};

export default placements;